import { useQuery } from '@tanstack/react-query';
import { getDeliverObjectIdPhase } from '../api/deliver-object-api/deliver-object-api';
import { DeliverObjectDto } from '../api/model';

export const usePhaseDeliverables = (phaseId: number, isProjectExtended: boolean = false) => {
  const query = useQuery({
    queryKey: [`phase-deliverables-${phaseId}`],
    queryFn: async () => {
      if (!phaseId) return [];
      const result = await getDeliverObjectIdPhase(phaseId);
      // Ensure we always return an array
      if (!result) return [];
      if (Array.isArray(result)) return result;

      return [result];
    },
    enabled: !!phaseId && phaseId > 0,
    staleTime: 0,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
  });
  
  // Filter deliver objects
  const rawData = query.data || [];
  const deliverables = Array.isArray(rawData) ? rawData : [];
  
  // Show all deliverables . extend logic cleared
  const filteredDeliverables = deliverables;

  return {
    deliverables: filteredDeliverables,
    isLoading: query.isLoading,
    error: query.error
  };
};